export class ColorUtil {
	static SortColors (...colors) {
		const colorsMap = new Map();
		colors.forEach(color => {
			const numberValue = this.ToNumber(color);
			colorsMap.set(color, numberValue);
			colorsMap.set(numberValue, color);
		});
		
		return Array.from(colorsMap.keys())
			.filter(key => Number.isSafeInteger(key))
			.slice().sort((a, b) => a - b)
			.map(key => colorsMap.get(key));
	}
	
	static ToNumber(color) {
		return Number(color.replace("#", "0x"));
	}

	static isLightColor(hex) {
		const clean = hex.replace('#', '');
		const r = parseInt(clean.slice(0, 2), 16);
		const g = parseInt(clean.slice(2, 4), 16);
		const b = parseInt(clean.slice(4, 6), 16);
		return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5;
	}

	static isDarkColor(hex) {
		return !ColorUtil.isLightColor(hex);
	}
}